import React from "react";

/**
 * Cross-platform flag icon component using flag-icons CSS library.
 * Works on all OS including Windows (which doesn't support emoji flags).
 *
 * Uses ISO 3166-1 alpha-2 country codes (flag-icons CSS).
 * For language codes (en, pt), maps to the corresponding country code (gb, pt).
 */

// Map language codes to country codes for flag-icons CSS
const LANG_TO_COUNTRY = {
  en: "gb",
  fr: "fr",
  nl: "nl",
  es: "es",
  de: "de",
  it: "it",
  pt: "pt",
  pl: "pl",
  ru: "ru",
};

const FlagIcon = ({ code, size = 20, style = {}, className = "" }) => {
  const countryCode = LANG_TO_COUNTRY[code] || code;

  return (
    <span
      className={`fi fi-${countryCode} ${className}`}
      style={{
        fontSize: size,
        borderRadius: 2,
        verticalAlign: "middle",
        ...style,
      }}
    />
  );
};

export default FlagIcon;
